var React = require('react');

function ContentBars (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m42,550.67c-23.19,0-42-18.81-42-42v-74.67c0-23.19,18.81-42,42-42s42,18.81,42,42v74.67c0,23.19-18.81,42-42,42Z","key":0}),React.createElement("path",{"d":"m228.67,550.67c-23.19,0-42-18.81-42-42v-205.33c0-23.19,18.81-42,42-42s42,18.81,42,42v205.33c0,23.19-18.81,42-42,42Z","key":1}),React.createElement("path",{"d":"m415.33,550.67c-23.19,0-42-18.81-42-42V172.67c0-23.19,18.81-42,42-42s42,18.81,42,42v336c0,23.19-18.81,42-42,42Z","key":2}),React.createElement("path",{"d":"m602,550.67c-23.19,0-42-18.81-42-42V42c0-23.19,18.81-42,42-42s42,18.81,42,42v466.67c0,23.19-18.81,42-42,42Z","key":3})]);
}

ContentBars.defaultProps = {"id":"uuid-b029767f-faf7-43c2-845e-62b1e38d91c9","data-name":"Layer 1","width":"644","height":"550.67","viewBox":"0 0 644 550.67"};

module.exports = ContentBars;

ContentBars.default = ContentBars;
